import * as S from "./NotificationEvent.styles";
// import { ReactComponent as IconAlarm } from "../../../styles/assets/svg/icon-alarm-blue.svg";

interface NotificationEventContentItemProps {
    dummydata: { header: string; date: string; content: string }[];
}

export const NotificationEventContentItem = ({ dummydata }: NotificationEventContentItemProps) => {
    return (
        <S.MainContentsItemLayout>
        {dummydata.map((dummydata, index) => (
            <S.MainContentsItem key={index}>
                {/* <S.DataHeadBox>
                    <S.DataHeadBox className="title">
                    <S.StyledText>{dummydata.header}</S.StyledText>
                    </S.DataHeadBox>
                </S.DataHeadBox> */}
                <S.TitContentBox>
                    <S.DataHeadBox className="title">
                        <S.StyledText>{dummydata.header}</S.StyledText>
                    </S.DataHeadBox>
                    <S.DataItemBox>{dummydata.content}</S.DataItemBox>
                </S.TitContentBox>
                <S.ProfileDate>{dummydata.date}</S.ProfileDate>
            </S.MainContentsItem>
        ))}
        </S.MainContentsItemLayout>
    );
};

// export const AlarmContentItem = ({dummydata}: AlarmContentItemProps) => {
//   return (
//     <>
//       <S.MainContentsItem key={index}>
//         <S.DataHeadBox>
//           <div>
//             <IconAlarm width={25} height={25} />
//             <S.StyledText>헤더</S.StyledText>
//           </div>
//           <S.ProfileDate>2022-08-16 15:32:32</S.ProfileDate>
//         </S.DataHeadBox>

//         <S.DataItemBox>
//           <p>배차가 취소 되었습니다.</p>
//         </S.DataItemBox>
//       </S.MainContentsItem>

//       <S.MainContentsItem>
//         <S.DataHeadBox>
//           <div>
//             <IconAlarm width={25} height={25} />
//             <S.StyledText>헤더</S.StyledText>
//           </div>
//           <S.ProfileDate>2022-08-16 15:32:32</S.ProfileDate>
//         </S.DataHeadBox>

//         <S.DataItemBox>
//           <p>배차가 완료되었습니다.운송을 시작합니다.</p>
//         </S.DataItemBox>
//       </S.MainContentsItem>
//     </>
//   );
// };
